<script setup lang="ts">
import { formatDate } from '@/utils'
import UIKit from '@pocketprep/ui-kit'
import { computed } from 'vue'
const { Icon, Tag } = UIKit

const {
    status,
    isDark,
    isLegacy,
    availableDate = '',
    dueDate = '',
} = defineProps<{
    status: 'draft' | 'available' | 'upcoming' | 'closed'
    isDark?: boolean
    availableDate?: string | Date
    dueDate?: string | Date
    isLegacy?: boolean
}>()

const formattedAvailableDate = computed(() => {
    if (!availableDate) {
        return '--'
    }
    return formatDate(availableDate)
})

const formattedDueDate = computed(() => {
    if (!dueDate) {
        return '--'
    }
    return formatDate(dueDate)
})

</script>

<template>
    <div class="assignment-dates">
        <Icon
            type="calendarPicker"
            class="assignment-dates__icon"
            :class="{'assignment-dates__icon--dark': isDark}"
        />
        <div class="assignment-dates__text">
            {{ isLegacy ? 'N/A' : `${formattedAvailableDate} - ${formattedDueDate}` }}
        </div>
        <Tag
            :isDarkMode="isDark"
            :isDraftTag="status === 'draft'"
            :isAvailableTag="status === 'available'"
            :isUpcomingTag="status === 'upcoming'"
            :isClosedTag="status === 'closed'"
            size="large"
        >
            <template #tagMessage>
                <span class="assignment-dates__status">
                    {{ status }}
                </span>
            </template>
        </Tag>
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

.assignment-dates {
    display: flex;
    color: $fog;
    font-size: 14px;
    height: 20px;
    align-items: center;

    &__icon {
        margin-right: 6px;
        color: $slate;

        &--dark {
            color: $fog;
        }
    }

    &__text {
        margin-right: 10px;
    }

    &__status {
        text-transform: capitalize;
    }
}
</style>
